import React, { useState, useEffect } from "react";
import "./Help.css";
import { FaArrowLeft, FaSearch } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE } from "../apiConfig";


const Help = () => {
  const [helpData, setHelpData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchHelpData = async () => {
      const token = localStorage.getItem("token");

      try {
        setLoading(true);
        const response = await fetch(`${API_BASE}/therapist_api/get_help_content.php`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
          }
        });

        const result = await response.json();

        if (result.status && result.data) {
          setHelpData(result.data);
        }
      } catch (error) {
        console.error("Error fetching help data:", error);
        setError("Failed to load help content. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchHelpData();
  }, []);

  // Filter logic for title and description
  const filteredData = helpData.filter((item) => {
    const query = searchQuery.toLowerCase();
    const title = item.title ? item.title.toLowerCase() : "";
    const description = item.description ? item.description.toLowerCase() : "";

    return title.includes(query) || description.includes(query);
  });

  return (
    <>
      <div className="help-header-row">
        <Link onClick={() => navigate(-1)} className="back-btn2" aria-label="Go back to dashboard">
          <FaArrowLeft className="back-icon" aria-hidden="true" />
          Previous page
        </Link>
        <div className="common-page-header">
          <h1 className="common-page-title">Help</h1>
          <p className="common-page-subtitle">Understand your clinical pathway application.</p>
        </div>
      </div>
      <main className="GuideLibrary">
        {/* Search Bar */}
        <div className="fixed-header-wrapper">
          <div className="search-wrapper1">
            <input
              type="search"
              placeholder="Search"
              aria-label="Search help articles"
              className="rounded-pill search-input1"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <FaSearch className="search-icon1" aria-hidden="true" />
          </div>
        </div>



        {loading && (
          <p aria-live="polite" style={{ textAlign: "center", color: "gray", padding: "20px" }}>
            Loading help content...
          </p>
        )}

        {error && (
          <p role="alert" style={{ textAlign: "center", color: "red", padding: "20px" }}>
            {error}
          </p>
        )}

        {!loading && !error && filteredData.length === 0 && (
          <p role="status" style={{ textAlign: "center", color: "gray", padding: "20px" }}>
            No results found for "{searchQuery}"
          </p>
        )}

        {/* Help Cards */}
        {/* Cards Scrollable Container */}
        <div className="scrollable-container">
          <div className="guide-content">
            {filteredData.map((item) => (
              <div key={item.id} className="help-section">
                <h3>{item.title}</h3>
                <div className="help-card">
                  <div className="help-image">
                    <video width="300px" height="180px" controls aria-label={`Video tutorial: ${item.title}`}>
                      <source src={item.video} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div className="help-content">
                    <p
                      style={{
                        fontSize: '16px',
                        color: '#474947',
                        textAlign: "justify",
                        lineHeight: "1.6",
                        margin: "0 auto",
                        padding: '10px 18px 3px 0px'
                      }}
                    >{item.description}</p>
                  </div>
                </div>

                <div className="help-actions">
                  <>
                    <div className="steps-btn">
                      Steps to follow
                    </div>{'>'}
                    {/* Parsing steps string into clickable buttons/labels */}
                    {item.steps && item.steps.split('>').map((step, index) => (
                      <React.Fragment key={index}>
                        <p className="steps-btn5">{step.trim()}</p>
                        {index < item.steps.split('>').length - 1 && (
                          <i className="fas fa-chevron-right"></i>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

    </>
  );
};

export default Help;
